export enum Routes {
  ALL = '*',
  HOME = '/',
  SERVICES = '/services',
  ABOUT_US = '/about-us',
  BLOG = '/blog',
  CONTACTS = '/contacts',
  OUR_TEAM = '/our-team',
  FAQS = '/faqs',
  SOLUTIONS = '/solutions',
  ELEMENTS = '/elements',
  NOT_FOUND = '/not-found',
}
